module.exports = __webpack_public_path__ + "img/cuidan.1630993415105.png";